module.exports = __webpack_public_path__ + "img/MetaShoplogo.598c512b.svg";